import FormatMessage from 'format-message';

export default class TranslationUtil {
    constructor(translations, fallbackTranslations) {
        this.translations = translations;
        this.fallbackTranslations = fallbackTranslations;
        /**
         * FormatMessage's setup function let you specify a translations object, but it expects
         * all locales to be present. Since we're only supplying a single locale of translations
         * to the client side code, we'll ignore missing translation warnings and check for
         * missing keys ourselves when we generate the translated text, otherwise it'll generate
         * a console warning on every call to getTranslation.
         */
        FormatMessage.setup({
            missingTranslation: 'ignore'
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getMessageFromTranslations(key, translations) {
        try {
            return translations[key];
        } catch (e) {
            return undefined;
        }
    }

    getMessage(key) {
        return this.getMessageFromTranslations(key, this.translations)
            || this.getMessageFromTranslations(key, this.fallbackTranslations);
    }

    getTranslation(key, params = {}, dontIgnore) {
        const message = this.getMessage(key);
        if (!message) {
            // Either the last prop in the path was undefined, or we threw an exception
            return dontIgnore ? undefined : `!!! ${key} !!!`;
        }
        return FormatMessage(String(message), params);
    }

    hasTranslation(key) {
        const message = this.getMessage(key);
        return !!message;
    }

    /* eslint-disable no-param-reassign */
    /*
    Function for mapping country translations to an object of form
    { countryName: 'countryTranslation' }
    Update prefix if the key names every change,
    and keys MUST end with the country code, i.e. 'us'
    */
    mapCountryTranslations() {
        const prefix = 'lyp.leadForm.phoneInput.countries.';
        const translationSource = this.translations || this.fallbackTranslations;
        const countryCodeList = Object.keys(
            translationSource
        ).filter(key => key.startsWith( // filter to only country code keys
            prefix
        )).map(countryKey => countryKey.replace(prefix, '')); // remove everything except the country code
        return countryCodeList.reduce((map, country) => {
            map[country] = this.getTranslation(`${prefix}${country}`); // aggregate key value pairs in map
            return map;
        }, {});
    }
}

export const transformToArray = object => (Object.keys(object)
    .map(key => ({ key, value: object[key] || '' })));

export const transformToMap = list => list.reduce((acc, i) => {
    acc[i.key] = i.value;
    return acc;
}, {});
